import Slider from 'react-slick'
import { useEffect, useRef } from 'react'
import { GridCardPlaceholder } from './GridCardPlaceholder'
import { GridCard } from './GridCard'
import { CarGridDetails } from './CarCards/CarGridDetails'
import Button from '../AccountV2/components/Button'
import '../../assets/stylesheets/modules/carousel/carousel.scss'

const PLACEHOLDER_KEYS = Array.from(
  { length: 20 },
  (_, index) => `carousel-placeholder-${index}`
)

function MobilePrevArrow(props) {
  const { className, onClick } = props
  return (
    <button
      className={`${className} mobile-prev-arrow`}
      aria-label="items carousel prev"
      type="button"
      data-role="none"
      style={{ display: 'block' }}
      onClick={onClick}
    />
  )
}

function MobileNextArrow(props) {
  const { className, onClick } = props
  return (
    <button
      className={`${className} mobile-next-arrow`}
      aria-label="items carousel next"
      type="button"
      data-role="none"
      style={{ display: 'block' }}
      onClick={onClick}
    />
  )
}

export const ItemsCarousel = ({
  cars,
  openGarageModal,
  loading,
  currency,
}) => {
  const ref = useRef(null)
  const containerRef = useRef(null)

  const syncHiddenSlideFocusability = () => {
    if (!containerRef.current) return

    containerRef.current.querySelectorAll('.slick-slide').forEach((slide) => {
      const slideIsHidden = slide.getAttribute('aria-hidden') === 'true'

      slide.querySelectorAll('a, button').forEach((element) => {
        if (slideIsHidden) {
          element.setAttribute('tabindex', '-1')
        } else {
          element.removeAttribute('tabindex')
        }
      })
    })
  }

  useEffect(syncHiddenSlideFocusability, [cars, loading])

  if (!cars && !loading) return null

  if (loading) {
    return (
      <div className="mt-3 row">
        {PLACEHOLDER_KEYS.map((placeholderKey) => (
          <GridCardPlaceholder key={placeholderKey} />
        ))}
      </div>
    )
  }

  const handlePrevSlide = () => {
    ref.current.slickPrev()
  }

  const handleNextSlide = () => {
    ref.current.slickNext()
  }

  const settings = {
    afterChange: syncHiddenSlideFocusability,
    swipeToSlide: true,
    focusOnSelect: true,
    speed: 250,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: <MobilePrevArrow />,
          nextArrow: <MobileNextArrow />,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: <MobilePrevArrow />,
          nextArrow: <MobileNextArrow />,
        },
      },
    ],
  }

  return (
    <>
      <div className="section-heading align-items-center mb-4 slider-head-wrapper">
        <h2 className="col-md-auto mb-0 pe-md-0 fw-bold text-dark">
          {I18n.t('carrousel_title.premium_cars')}
        </h2>
        <div>
          <Button
            type="button"
            id="carousel-prev-button"
            className="carousel-button prev"
            onClick={() => handlePrevSlide()}
          >
            <i className="fa fa-arrow-left" />
          </Button>
          <Button
            type="button"
            id="carousel-next-button"
            className="carousel-button next"
            onClick={() => handleNextSlide()}
          >
            <i className="fa fa-arrow-right" />
          </Button>
        </div>
      </div>

      <div className="slider-container" ref={containerRef}>
        <Slider ref={ref} {...settings}>
          {cars.map((car) => (
            <div className="mb-4" key={car.id}>
              <GridCard
                image={{
                  src: car.image,
                  alt: 'Suggestion car image',
                }}
                url={`${car.car_path}`}
                title={car.car_title}
                description={car.car_details}
                country={car.location_country}
                withSoldMark={car.car_status === 'sold'}
                isPremium
              >
                <CarGridDetails
                  car={car}
                  currency={currency}
                  displayAddToGarageButton
                  openGarageModal={openGarageModal}
                />
              </GridCard>
            </div>
          ))}
        </Slider>
      </div>
    </>
  )
}
